export default __webpack_public_path__ + "static/media/map-filter-reduce.c11b43cb.png";